import * as React from 'react';
import {ControlBar} from '../../components/ControlBar/ControlBar';
import {useControlBarContainer} from './ControlBarContainer.enhancers';
import {IOuter} from './ControlBarContainer.types';

export const ControlBarContainer: React.FunctionComponent<IOuter> = ({isNavigationButtonsHidden}) => {
  const {
    duration,
    progress,
    isPlaying,
    handlePlayPauseClick,
    handleNextClick,
    handlePreviousClick,
    handleProgressChange,
  } = useControlBarContainer();

  return (
    <ControlBar
      isPlaying={isPlaying}
      onPlayPauseClick={handlePlayPauseClick}
      onNextClick={handleNextClick}
      onPreviousClick={handlePreviousClick}
      onProgressChange={handleProgressChange}
      progress={progress}
      duration={duration}
      isNavigationButtonsHidden={isNavigationButtonsHidden}
    />
  );
};

ControlBarContainer.displayName = 'ControlBarContainer';
